

import React, { memo, useMemo } from 'react';
import cx from 'classnames';



import { DataTableContext } from '../context/dataTableContext';
import { useDataTableContextValue } from '../context/useDataTableContextValue';
import { DATA_TABLE_COLUMN_FIELD } from '../../../../common/constants/column/dataTableColumnField';
import { getDataTableColumns } from '../utils/factories/dataTableColumnFactory';


import { DATA_TABLE_STYLE_TYPE } from '../../../../common/constants/dataTableStyleType';


import { DATA_TABLE_TREE_STYLE_TYPE } from '../../../../common/constants/dataTableTreeStyleType';

import DataTableContentContainer from './DataTableContentContaner';
import '../styles/_data-table.scss';

















const DataTable = (props) => {
  const {
    columns,
    rows = [],
    columnFieldId = DATA_TABLE_COLUMN_FIELD.ID,
    columnTreeParentFieldId = DATA_TABLE_COLUMN_FIELD.PARENT_ID,
    sortOptions = {},
    infiniteScrollOptions,
    styleType = DATA_TABLE_STYLE_TYPE.PRIMARY,
    treeStyleType = DATA_TABLE_TREE_STYLE_TYPE.SIMPLE,
    isLoading = false,
    getRowIndicator,
    getOnRowClick,
    isV2Design = false
  } = props;

  const controlColumns = useMemo(
    () => getDataTableColumns(columns, columnFieldId), [columns, columnFieldId]
  );

  const contextValue = useDataTableContextValue({
    columns: controlColumns,
    rows,
    columnFieldId,
    columnTreeParentFieldId,
    sortOptions,
    infiniteScrollOptions,
    styleType,
    treeStyleType,
    isLoading,
    getRowIndicator,
    getOnRowClick
  });
  const { hasData } = contextValue;

  return (
    <DataTableContext.Provider value={contextValue}>
      <div
        className={cx(
          'data-table', {
            [`data-table--${styleType}`]: styleType,
            'data-table--empty': !hasData,
            'data-table--v2-design': isV2Design
          }
        )}>

        <DataTableContentContainer />
      </div>
    </DataTableContext.Provider>);

};

export default memo(DataTable);